import type { Locale } from './types'

export const DEFAULT_LOCALE: Locale = 'es'
export const SUPPORTED_LOCALES: Locale[] = ['es', 'en', 'pt']
export const LOCALE_LABELS: Record<Locale, string> = {
  es: 'Español',
  en: 'English',
  pt: 'Português',
}
